import { makeStyles } from "@mui/styles"

export const useOverrides = makeStyles({
  closeIcon: ({ noPadding }) => ({
    "&.MuiIconButton-root": {
      marginRight: noPadding ? "30px" : "0",
    },
  }),

  dialogActions: ({ noPadding }) => ({
    "&.MuiDialogActions-root": {
      justifyContent: "flex-start",
      padding: noPadding ? "3.4rem 0" : "3.4rem 30px",
    },
  }),

  dialogContent: ({ noPadding, overflow, resizable, width }) => ({
    "&.MuiDialogContent-root": {
      display: "flex",
      flexFlow: "column",
      flex: 1,
      fontSize: "1.4rem",
      height: resizable ? "calc(100% - 40px - 3.4rem - 2rem)" : "auto",
      overflowX: overflow ? "visible" : "inherit",
      overflowY: "overlay",
      overflow,
      padding: noPadding ? "0" : "0 30px",
      position: "relative",
      width: width || "auto",
    },
  }),

  dialogTitle: ({ noPadding, title }) => ({
    "&.MuiDialogTitle-root": {
      display: "flex",
      justifyContent: "space-between",
      color: "#554854",
      fontSize: "20px",
      fontWeight: "700",
      padding: noPadding
        ? `3.4rem 0 ${title ? "5px" : 0} 30px`
        : `3.4rem 30px ${title ? "5px" : 0} 30px`,
    },
  }),

  loadingSpinnerWrapper: {
    "& [class*=MuiCircularProgress-root]": {
      left: "50%",
      position: "absolute",
      top: "50%",
    },

    height: "100%",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%",
    zIndex: 1,
  },

  paper: ({ width }) => ({
    "&.MuiDialog-paper": {
      backgroundColor: "#f4f4f4",
      border: "none",
      borderRadius: "4px",
      minWidth: width || 720,
    },

    "@media print": {
      "&.MuiDialog-paper": { display: "none" },
    },
  }),

  root: ({ maxHeight, overflow, width }) => ({
    "& .MuiPaper-root-MuiDialog-paper": {
      backgroundColor: "#f4f4f4",
      border: "none",
      borderRadius: "4px",
      maxHeight,
      minWidth: width || 720,
      overflowY: overflow ? "visible" : undefined,
    },

    "& .MuiPaper-root": {
      overflow: overflow ? "visible" : "inherit",
    },

    "& .MuiInputBase-input.MuiFilledInput-input, & .MuiInputBase-root": {
      backgroundColor: "#D3D3D3 !important",
      overflow: "hidden",
    },

    "& > :first-child": {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  }),

  "& .MuiToolbar-root": {
    backgroundColor: "#f4f4f4",
  },

  spacing: {
    "&.MuiDialogActions-root": {
      "& > :not(:first-child)": {
        marginLeft: "24px",
      },
    },
  },
})

export const useDynamicPaperStyles = makeStyles({
  root: ({ maxHeight, noPadding, overflow, renderButtons, width }) => ({
    "&.MuiDialog-paper": {
      backgroundColor: "#f4f4f4",
      border: "none",
      borderRadius: "4px",
      maxHeight,
      minWidth: width || 720,
      overflowY: overflow ? "visible" : undefined,
      paddingBottom: `${noPadding ? "0" : renderButtons ? "0" : "3.4rem"}`,
    },
  }),
})
